import {
  ChakraProvider,
  createSystem,
  defaultConfig,
  defineConfig,
} from '@chakra-ui/react';
import { ColorModeProvider } from '@components/ui/color-mode';

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        argos: {
          50: { value: '#fff8eb' },
          100: { value: '#ffefc6' },
          200: { value: '#ffe49e' },
          300: { value: '#ffd975' },
          400: { value: '#ffcc4d' },
          500: { value: '#ffb62e' },
          600: { value: '#e29b25' },
          700: { value: '#c1831d' },
          800: { value: '#9e6a17' },
          900: { value: '#7c5311' },
          950: { value: '#5b3d0c' },
        },
        grayscale: {
          50: { value: '#F5F5F5' },
          100: { value: '#EBEBEB' },
          200: { value: '#CCCCCC' },
          300: { value: '#AFAFAF' },
          400: { value: '#878787' },
          500: { value: '#666565' },
          600: { value: '#4D4D4D' },
          700: { value: '#282827' },
          800: { value: '#1F1F1E' },
          900: { value: '#141414' },
          950: { value: '#0A0A0A' },
        },
      },
    },
    semanticTokens: {
      colors: {
        argos: {
          solid: {
            value: { _light: "{colors.grayscale.700}", _dark: "{colors.argos.500}" },
          },
          contrast: {
            value: { _light: "{colors.white}", _dark: "{colors.grayscale.900}" },
          },
          fg: {
            value: { _light: "{colors.grayscale.700}", _dark: "{colors.argos.500}" },
          },
          muted: {
            value: "{colors.argos.100}",
          },
          subtle: {
            value: { _light: "{colors.argos.300}", _dark: "{colors.grayscale.700}" },
          },
          emphasized: {
            value: "{colors.argos.300}",
          },
          focusRing: {
            value: "{colors.argos.500}",
          },
        },
        grayscale: {
          DEFAULT: {
            value: { _light: "{colors.grayscale.100}", _dark: "{colors.grayscale.800}" },
          },
          fg: {
            value: { _light: "{colors.grayscale.50}", _dark: "{colors.grayscale.700}" },
          },
        },
        bg: {
          DEFAULT: {
            value: { _light: "{colors.white}", _dark: "{colors.grayscale.900}" },
          },
          muted: {
            value: { _light: "{colors.grayscale.100}", _dark: "{colors.grayscale.800}" },
          },
          hover: {
            value: { _light: "{colors.grayscale.200}", _dark: "{colors.grayscale.700}" },
          }
        },
        border: {
          DEFAULT: {
            value: { _light: "{colors.grayscale.500}", _dark: "{colors.grayscale.300}" },
          },
          muted: {
            value: { _light: "{colors.grayscale.300}", _dark: "{colors.grayscale.600}" },
          },
        },
      },
    },
  },
});

const system = createSystem(defaultConfig, config);

const Provider = ({ children }: Props) => {
  return (
    <ChakraProvider value={system}>
      <ColorModeProvider defaultTheme="dark">
        {children}
      </ColorModeProvider>
    </ChakraProvider>
  );
};

type Props = {
  children: React.ReactNode;
};

export default Provider;
